import script from "./SKUHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./SKUHistory.vue?vue&type=script&setup=true&lang=js"

import "./SKUHistory.vue?vue&type=style&index=0&id=63d8b5cb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d8b5cb"]])

export default __exports__